import styled from 'styled-components';
import breakpoints from '../breakpoints';

const Button = styled.button`
    border: 1px solid #006AFF;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    height: 54px;
    letter-spacing: 0;
    line-height: 21px;
    text-align: center;
`;

const Hero = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    width: 240px;
`;

const Primary = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    width: 184px;
`;

const Secondary = styled(Button)`
    background-color: #FFFFFF;
    color: #006AFF;
    width: 184px;
`;

const Cta = styled(Button)`
    background-color: #006AFF;
    color: #FFFFFF;
    height: 42px;
    width: 100%;

    @media ${breakpoints.medium} {
        width: 155px;
    }
`;

export default {
    Hero,
    Primary,
    Secondary,
    Cta,
};
